(function () {
	'use strict';

	const OPEN_CLASS = 'single-product__accordion--open';
	const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

	const initProductSlider = (sliderRoot) => {
		const swiperEl = sliderRoot.querySelector('.single-product__swiper');
		const paginationEl = sliderRoot.querySelector('.single-product__bullets');
		const slidesCount = swiperEl?.querySelectorAll('.swiper-slide').length ?? 0;

		if (!swiperEl || slidesCount === 0) {
			return;
		}

		const hasMultipleSlides = slidesCount > 1;

		const swiper = new Swiper(swiperEl, {
			slidesPerView: 1,
			loop: false,
			grabCursor: hasMultipleSlides,
			simulateTouch: hasMultipleSlides && isTouchDevice,
			allowTouchMove: hasMultipleSlides,
			speed: 300,
			watchOverflow: true,
			...(paginationEl && hasMultipleSlides
				? {
						pagination: {
							el: paginationEl,
							clickable: true,
						},
					}
				: {}),
		});

		if (!hasMultipleSlides || isTouchDevice) {
			return;
		}

		let rafId = null;

		const handleMouseMove = (event) => {
			if (rafId) {
				return;
			}

			rafId = requestAnimationFrame(() => {
				rafId = null;

				const rect = sliderRoot.getBoundingClientRect();
				const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
				const index = Math.round(ratio * (slidesCount - 1));

				if (index !== swiper.activeIndex) {
					swiper.slideTo(index);
				}
			});
		};

		sliderRoot.addEventListener('mousemove', handleMouseMove, { passive: true });
	};

	const initQuantity = (wrapper) => {
		const field = wrapper.querySelector('.single-product__quantity-field');
		const minusBtn = wrapper.querySelector('.single-product__quantity-btn--minus');
		const plusBtn = wrapper.querySelector('.single-product__quantity-btn--plus');

		if (!field || !minusBtn || !plusBtn) {
			return;
		}

		const min = 1;
		let max = parseInt(wrapper.dataset.max, 10);

		if (Number.isNaN(max) || max < min) {
			max = min;
		}

		const clamp = (value) => Math.min(max, Math.max(min, value));

		const setValue = (value) => {
			field.value = String(clamp(value));
		};

		minusBtn.addEventListener('click', () => {
			setValue(parseInt(field.value, 10) - 1);
		});

		plusBtn.addEventListener('click', () => {
			setValue(parseInt(field.value, 10) + 1);
		});

		field.addEventListener('input', () => {
			field.value = field.value.replace(/\D/g, '');
		});

		field.addEventListener('blur', () => {
			const value = parseInt(field.value, 10);

			if (Number.isNaN(value)) {
				setValue(min);
				return;
			}

			setValue(value);
		});

		setValue(parseInt(field.value, 10) || min);
	};

	const initAccordion = (accordion) => {
		const summary = accordion.querySelector('.single-product__accordion-summary');
		const content = summary?.nextElementSibling;

		if (!summary || !content) {
			return;
		}

		summary.setAttribute('role', 'button');
		summary.setAttribute('tabindex', '0');
		summary.setAttribute('aria-expanded', 'false');

		const toggle = () => {
			const isOpen = accordion.classList.toggle(OPEN_CLASS);
			summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		};

		summary.addEventListener('click', (event) => {
			event.preventDefault();
			toggle();
		});

		summary.addEventListener('keydown', (event) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				toggle();
			}
		});
	};

	let galleryPopupSwiper = null;

	const getGallerySlidesData = () =>
		[...document.querySelectorAll('.single-product__slide-open')]
			.map((button) => ({
				src: button.dataset.fullSrc || button.querySelector('img')?.currentSrc || button.querySelector('img')?.src || '',
				alt: button.querySelector('img')?.alt || '',
			}))
			.filter((slide) => slide.src);

	const renderGalleryPopup = (initialIndex = 0) => {
		const popup = document.getElementById('product-gallery-popup');

		if (!popup || typeof Swiper === 'undefined') {
			return null;
		}

		const sliderRoot = popup.querySelector('.productGalleryPopupSlider');
		const wrapper = sliderRoot?.querySelector('.swiper-wrapper');
		const navigation = popup.querySelector('.swiper-navigation');
		const bulletsEl = popup.querySelector('.single-product__bullets');
		const progressEl = popup.querySelector('.pagination');
		const slidesData = getGallerySlidesData();

		if (!wrapper || slidesData.length === 0) {
			return null;
		}

		wrapper.innerHTML = '';

		slidesData.forEach(({ src, alt }) => {
			const slide = document.createElement('div');
			const image = document.createElement('img');

			slide.className = 'swiper-slide';
			image.className = 'product-gallery-popup__img';
			image.src = src;
			image.alt = alt;
			image.loading = 'lazy';
			slide.appendChild(image);
			wrapper.appendChild(slide);
		});

		const hasMultipleSlides = slidesData.length > 1;

		if (navigation) {
			navigation.hidden = !hasMultipleSlides;
		}

		if (bulletsEl) {
			bulletsEl.hidden = !hasMultipleSlides;
			bulletsEl.innerHTML = '';
		}

		if (progressEl) {
			progressEl.hidden = !hasMultipleSlides;
		}

		if (galleryPopupSwiper) {
			galleryPopupSwiper.destroy(true, true);
			galleryPopupSwiper = null;
		}

		const renderBullets = (activeIndex) => {
			if (!bulletsEl || !hasMultipleSlides) {
				return;
			}

			bulletsEl.innerHTML = slidesData
				.map((_, index) => {
					const isActive = index === activeIndex;
					return `<button type="button" class="swiper-pagination-bullet${isActive ? ' swiper-pagination-bullet-active' : ''}" aria-label="Слайд ${index + 1}"></button>`;
				})
				.join('');

			bulletsEl.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
				bullet.addEventListener('click', () => {
					galleryPopupSwiper?.slideTo(index);
				});
			});
		};

		const updateBullets = (activeIndex) => {
			bulletsEl?.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
				bullet.classList.toggle('swiper-pagination-bullet-active', index === activeIndex);
			});
		};

		const initialSlide = Math.min(initialIndex, slidesData.length - 1);

		galleryPopupSwiper = new Swiper(sliderRoot, {
			slidesPerView: 1,
			loop: false,
			initialSlide,
			...(hasMultipleSlides && progressEl
				? {
						pagination: {
							el: progressEl,
							type: 'progressbar',
						},
					}
				: {}),
			navigation: {
				nextEl: '#product-gallery-popup .button-next',
				prevEl: '#product-gallery-popup .button-prev',
			},
		});

		renderBullets(initialSlide);

		galleryPopupSwiper.on('slideChange', () => {
			updateBullets(galleryPopupSwiper.activeIndex);
		});

		return galleryPopupSwiper;
	};

	const initGalleryPopup = () => {
		document.querySelectorAll('[data-target="product-gallery-popup"]').forEach((button) => {
			button.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopPropagation();

				const initialIndex = parseInt(button.dataset.slideIndex, 10) || 0;

				renderGalleryPopup(initialIndex);

				if (typeof Fancybox === 'undefined') {
					return;
				}

				Fancybox.show([{ src: '#product-gallery-popup', type: 'inline' }]);

				requestAnimationFrame(() => {
					galleryPopupSwiper?.update();
				});
			});
		});
	};

	const initRelatedProductsSlider = () => {
		const slider = document.querySelector('.relatedProductsSlider');

		if (!slider || typeof Swiper === 'undefined') {
			return;
		}

		new Swiper(slider, {
			slidesPerView: 2,
			spaceBetween: 10,
			loop: false,
			pagination: {
				el: '.relatedProductsSlider .pagination',
				type: 'progressbar',
			},
			navigation: {
				nextEl: '.relatedProductsSlider .button-next',
				prevEl: '.relatedProductsSlider .button-prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 5,
					spaceBetween: 14,
				},
				1201: {
					slidesPerView: 5,
					spaceBetween: 16,
				},
			},
		});
	};

	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('.single-product__accordion').forEach(initAccordion);
		document.querySelectorAll('.single-product__slider').forEach(initProductSlider);
		document.querySelectorAll('.single-product__quantity-wrapper').forEach(initQuantity);
		initGalleryPopup();
		initRelatedProductsSlider();
	});
})();
